import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'DevicesPcOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-pc-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 9v10h-6v-14h2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13 9h9v7h-2m-4 0h-4v-4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 19h5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 17v2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 13v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 16v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3l18 18"
    }, null), _createTextVNode(" ")]);
  }
};